import { FormEventHandler, ReactNode } from "react";
import WithServerCheck from "../WithServerCheck";

interface FormProps {
    children: ReactNode;
    onSubmit: FormEventHandler<HTMLFormElement>;
    [key: string]: any;
}

export const Form: React.FC<FormProps> = ({ children, onSubmit, ...props }) => {

    const onSubmitCustom: FormEventHandler<HTMLFormElement> = (e) => {
        e.preventDefault();
        onSubmit(e);
    }

    return (
        <>
                <WithServerCheck>
                    <form className="row" onSubmit={onSubmitCustom} {...props} noValidate>
                        {children}
                    </form>
                </WithServerCheck>
        </>
    )
}